import { LatLng } from "leaflet";
import { useState } from "react";
import { Marker, Popup, Tooltip } from "react-leaflet";
import { Card } from "./card";
import { MarkerData } from "./combined-markers";
import { MarkerIcon, detourMarkersIcons, fallBackIcon } from "./markers";

interface IMarkerProps {
  markerData: MarkerData[];
  hidePopup?: boolean;
}
export function AllMarkers({ markerData, hidePopup = false }: IMarkerProps) {
  const [popupOpen, setPopupOpen] = useState(false);
  return markerData.map(({ item, point }: MarkerData) => (
    <Marker
      key={item.id}
      icon={MarkerIcon({
        item: item,
        detourMarker:
          "detourType" in item ? detourMarkersIcons.get(item.detourType.name) : fallBackIcon,
      })}
      position={new LatLng(point.geometry.coordinates[1], point.geometry.coordinates[0])}
      eventHandlers={{
        popupopen: (event) => {
          setPopupOpen(true);
          const popupContainer = event.target._popup?._container as HTMLElement;
          if (popupContainer) {
            popupContainer.setAttribute("tabindex", "0");
            popupContainer.focus();
          }
        },
        keydown: (event) => {
          if (
            (popupOpen && event.originalEvent.key === "Tab") ||
            event.originalEvent.key === "Escape"
          ) {
            event.originalEvent.preventDefault();
            event.target.closePopup();
          } else if (event.originalEvent.key === "Enter" || event.originalEvent.key === " ") {
            event.originalEvent.preventDefault();
            event.target.openPopup();
          }
        },
        popupclose: () => {
          setPopupOpen(false);
        },
      }}
    >
      {"detourType" in item && (
        <Tooltip direction="auto">
          <strong>{item.name}</strong> ({item.detourType.name})
        </Tooltip>
      )}
      {!hidePopup && (
        <Popup>
          <Card item={item} />
        </Popup>
      )}
    </Marker>
  ));
}
